/**
 *
 * @param { String } FILE_URL Url of script to load
 * @param { Boolean } async If true, the script is loaded asynchronously
 * @param { String } type Type of the script tag
 * @returns Promise
 */
export const loadScript = (
  FILE_URL,
  async = true,
  type = "text/javascript"
) => {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement("script");

    scriptElement.type = type;
    scriptElement.async = async;
    scriptElement.src = FILE_URL;

    scriptElement.onload = resolve;
    scriptElement.onerror = reject;
    document.head.appendChild(scriptElement);
  });
};

/**
 * Sustituya a loadScriptAsync o loadScript
 * @param {String} url La url de la librería a cargar
 * @returns Una promesa de cada carga de la librería
 */

export function loadLib(url, idTag) {
  return new Promise((resolve, reject) => {
    globalThis.idTagDelio = idTag;

    const script = document.createElement("script");
    script.src = url;
    script.async = true;

    // Manejo de carga exitosa del script
    script.onload = () => {
      resolve(true);
    };

    // Manejo de errores al cargar el script
    script.onerror = () => {
      reject(new Error(`Error al cargar el script: ${url}`));
    };

    // Añadir el script al documento
    document.head.appendChild(script);
  });
}
export function loadLibTimeOut(url, idTag) {
  return new Promise((resolve, reject) => {
    globalThis.idTagDelio = idTag;
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => {
     const timeOut=setTimeout(() => {
        clearTimeout(timeOut)
        resolve(true); // Carga
      }, 50);
    };
    script.onerror = reject; // No carga
    document.head.appendChild(script);
  });
}

/**
 *
 * @param {Array} libs Array de objetos con las librerías a cargar
 */
export async function loadAllLibs(libs) {
  try {
    console.log("entro aqui por");
    const promises = libs.map((lib) => loadLib(lib.url));
    await Promise.all(promises);
  } catch (error) {
    console.error(errorWalmeric);
  }
}

/**
 *
 * @param { Array } arrayPromises Array of Promises to resolve
 * @returns response
 */

export const loadMultiScript = async (arrayPromises) => {
  try {
    const promises = await Promise.all(arrayPromises);
    return promises;
  } catch (error) {
    console.log(error);
  }
};

export const getUrlVar = function (variable, url) {
  var href = url || window.location.search;
  var i, pair;
  var query = href.split("?")[1];
  var vars = query ? query.split("&") : [];

  for (let i = 0; i < vars.length; i++) {
    pair = vars[i].split("=");
    if (pair[0] == variable && pair[1] !== "") return pair[1];
  }

  return "";
};

// Funcion para coger el leadId//
export const getVisitorId = (time) => {
  return new Promise((resolve, reject) => {
    setInterval(() => {
      if (globalThis.Piwik) {
        // @ts-ignore
        clearInterval();
        const idVisitor = globalThis.Piwik.getAsyncTracker().getVisitorId();
        resolve(idVisitor);
      } else {
        reject(new Error("Piwik no existe "));
      }
    }, time);
  });
};

// Funcion para medir la velocidad del internet

export const velocityInternet = async () => {
  // @ts-ignore
  const conexion =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  const obtenerDelayPorVelocidad = (velocidad) => {
    // Definición de umbrales en Mbps
    const umbral2G = 1; // Mbps
    const umbral3G = 3; // Mbps
    const umbral4G = 10; // Mbps

    if(velocidad<=umbral2G){
      return 9800
    }else if(velocidad>=umbral2G && velocidad <= umbral3G) {
      return 7000; // Tiempo para 3G o menor
    } else if (velocidad>=umbral3G && velocidad <= umbral4G) {
      return 2000; // Tiempo para 4G
    } else {
      return 0; // Tiempo para conexiones más rápidas (5G y superiores)
    }
  };

  if (conexion && typeof conexion.downlink === "number") {
    const velocidad = conexion.downlink;

    try {
      const delay = obtenerDelayPorVelocidad(velocidad);
      return await getVisitorId(delay);
    } catch (error) {
      console.error("Error al obtener el ID del visitante:", error);
      throw error; // Re-lanzar el error para su manejo posterior
    }
  } else {
    console.warn(
      "No se pudo determinar la velocidad de la conexión. Usando valor predeterminado."
    );
    // Si no se puede determinar la velocidad, se utiliza un valor predeterminado
    return await getVisitorId(2000);
  }
};

// Función que ejecuta getLeadId después de un retraso de 3 milisegundos (3000 milisegundos)

export const getLeadId = () => {
  return velocityInternet();
};

/**
 * Funcion que comprueba que Digital Data este cargado
 * **/

export function waitForDigitalData() {
  return new Promise(async (resolve, reject) => {
    let counter = 0;
    var MAX_COUNTER = 100;

    const interval = setInterval(() => {
      counter++;
      if (
        typeof globalThis.digitalData === "object" &&
        globalThis.digitalData
      ) {
        // @ts-ignore
        clearInterval(interval);
        resolve(globalThis.digitalData);
      } else if (counter > MAX_COUNTER) {
        // @ts-ignore
        clearInterval(interval);
        reject(new Error("Problemas en recogida Digital Data."));
      }
    }, 400);
  });
}
